module.exports = __webpack_public_path__ + "static/media/tell_us.ca36a3eb.png";